module.exports = __webpack_public_path__ + "img/moon-2.5e0afe94.svg";